export default { clockIn:new Date(), clockOut:new Date(), shopId:'', profileId:'', clockInImage:'', clockOutImage:'', id:'' }